// CardSection.tsx
import React from 'react';
import { Card } from 'react-bootstrap';
import { GraphDownArrow, GraphUpArrow } from 'react-bootstrap-icons';
import { formatCurrency } from '../../../../../../../utils/functions';
import { BillType } from '../../../types';

type CardSectionProps = {
  totalCurrentMonth: number;
  variationPercent: number;
  arrowColor: string;
  isNegative: boolean;
  maxBillThisMonth?: BillType;
};

const CardSection: React.FC<CardSectionProps> = ({
  totalCurrentMonth,
  variationPercent,
  arrowColor,
  isNegative,
  maxBillThisMonth,
}) => {
  // Icono según variación:
  const arrowIcon = isNegative ? <GraphDownArrow /> : <GraphUpArrow />;

  return (
    <div className="transaction-card-header-container">
      <Card className="transaction-card-header">
        <Card.Body className="transaction-card-body-container horizontal">
          <Card.Text className="transaction-card-text">
            <div className="transaction-section">
              <div className="transaction-data">
                {formatCurrency(totalCurrentMonth)}
              </div>
              <div className="transaction-label">Total a pagar mes actual</div>
            </div>
            <div className="divider" />
            <div className="transaction-section">
              <div className="transaction-data" style={{ color: arrowColor }}>
                {variationPercent.toFixed(2)}% {arrowIcon}
              </div>
              <div className="transaction-label">Variación de pago actual v/s Variación mes anterior</div>
            </div>
            <div className="divider" />
            <div className="transaction-section">
              <div className="transaction-data">
                {maxBillThisMonth ? (
                  <>
                    {maxBillThisMonth.bill_name} {formatCurrency(maxBillThisMonth.amount)}
                  </>
                ) : (
                  'No hay gastos este mes'
                )}
              </div>
              <div className="transaction-label">Cuenta mayor del mes actual</div>
            </div>
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CardSection;
